import api from '../axiosConfig';

const API_URL = '/api/batch-inventory-process';

export const getBatchProcesses = (params = {}) => api.get(API_URL, { params });
export const getBatchProcessById = (id) => api.get(`${API_URL}/${id}`);
export const getLastProcess = (inventoryId) => api.get(`${API_URL}/last-process/${inventoryId}`);
export const createBatchProcess = (data) => api.post(API_URL, data);
export const updateBatchProcess = (id, data) => api.put(`${API_URL}/${id}`, data);
export const deleteBatchProcess = (id) => api.delete(`${API_URL}/${id}`);
export const hasStoneProcess = (inventoryId) => api.get(`${API_URL}/has-stone-process/${inventoryId}`); 